import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIntegrationSettingById,
  fetchIntegrationConfiguration,
  upsertIntegrationSetting,
} from "../../features/integration-setting/integrationSettingSlice";
import Configuration from "./Configuration";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

function IntegrationSetting() {
  const { settingId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isOnboarding = location.pathname.includes("onboarding");
  const dispatch = useDispatch();
  const { setting, configurations, configLoading } = useSelector(
    (state) => state.integrationSetting,
  );

  const normalizeDefaultSettings = (defaultSettings) => {
    if (!Array.isArray(defaultSettings) || !defaultSettings.length) return {};

    return defaultSettings.reduce((acc, item) => {
      if (!item?.name || !Array.isArray(item.data)) return acc;

      acc[item.name] = item.isArray ? item.data : item.data[0] || {};

      return acc;
    }, {});
  };
  const [selectedDefaultSettings, setSelectedDefaultSettings] = useState({});

  const transformDefaultSettings = (settings) => {
    return Object.entries(settings).map(([name, value]) => ({
      name,
      data: Array.isArray(value) ? value : value && value.key ? [value] : [],
      isArray: Array.isArray(value),
    }));
  };

  useEffect(() => {
    if (settingId) {
      dispatch(fetchIntegrationSettingById({ settingUuid: settingId }));
    }
  }, [settingId, dispatch]);

  useEffect(() => {
    if (settingId) {
      dispatch(fetchIntegrationConfiguration({ settingUuid: settingId }));
    }
  }, [settingId, dispatch]);

  useEffect(() => {
    setSelectedDefaultSettings(
      normalizeDefaultSettings(setting?.defaultSettings),
    );
  }, [setting]);

  const handleSave = async () => {
    try {
      const data = {
        uuid: settingId,
        integrationId: setting?.integrationId?.uuid,
        defaultSettings: transformDefaultSettings(selectedDefaultSettings),
      };

      await dispatch(upsertIntegrationSetting(data));
      toast.success(`Configurations updated sucessfully`);
      navigate(
        isOnboarding
          ? `/onboarding/team-communication/integrations`
          : `/integrations`,
      );
    } catch (error) {
      console.error("Error updating setting:", error);
    }
  };

  return (
    <Configuration
      setting={setting}
      configurations={configurations}
      loading={configLoading}
      selectedDefaultSettings={selectedDefaultSettings}
      setSelectedDefaultSettings={setSelectedDefaultSettings}
      handleSave={handleSave}
      isOnboarding={isOnboarding}
    />
  );
}

export default IntegrationSetting;
